import { useSizeProp } from '@sgui-plus/hooks'
import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { Loading } from '@sgui-plus/icons-vue'
import type { ExtractPropTypes, Component } from 'vue'
import type button from './button.vue'

export const buttonType = [
  'default',
  'primary',
  'success',
  'warning',
  'info',
  'danger',
  'text',
  '',
] as const
export const buttonNativeType = ['button', 'submit', 'reset'] as const

export const buttonProps = buildProps({
  size: useSizeProp,
  disabled: Boolean,
  type: {
    type: String,
    values: buttonType,
    default: '',
  },
  icon: {
    type: definePropType<string | Component>([String, Object]),
    default: '',
  },
  nativeType: {
    type: String,
    values: buttonNativeType,
    default: 'button',
  },
  loading: Boolean,
  loadingIcon: {
    type: definePropType<string | Component>([String, Object]),
    default: () => Loading,
  },
  plain: Boolean,
  outline: Boolean,
  text: Boolean,
  round: Boolean,
  circle: Boolean,
  color: String,
  block: Boolean
} as const)

export const buttonEmits = {
  click: (evt: MouseEvent) => evt instanceof MouseEvent,
}

export type ButtonProps = ExtractPropTypes<typeof buttonProps>
export type ButtonEmits = typeof buttonEmits

export type ButtonType = ButtonProps['type']
export type ButtonNativeType = ButtonProps['nativeType']

export type ButtonInstance = InstanceType<typeof button>
